import { inject, Injectable } from '@angular/core';
import { DateFormatModel } from '@core/localization/date-format.model';
import { AvailableLanguage } from '@core/localization/available-language';
import { LOCALIZATION_CONFIG, LocalizationConfig } from '@core/localization/localization.config';
import { get } from 'lodash-es';
import { LanguageState } from '@core/localization/language.state';
import { convertDateTimeToDbFormat, convertDateToDbFormat } from '@core/localization/local-date-adapter.helpers';


@Injectable({
    providedIn: 'root',
})
export class LocalDateAdapter {
    readonly #languageState: LanguageState = inject(LanguageState);
    readonly #localizationConfig: LocalizationConfig = inject(LOCALIZATION_CONFIG);

    public get format(): DateFormatModel {
        const langCode: AvailableLanguage =
            this.#languageState.currentLang.toLowerCase() as AvailableLanguage;

        return get(this.#localizationConfig.dateFormats, langCode)
            || get(this.#localizationConfig.dateFormats, this.#localizationConfig.defaultLocale);
    }

    public prepareDateTimeForDB(dateFrom: Date | string, timeFrom: Date | string): string {
        return convertDateTimeToDbFormat(dateFrom, timeFrom);
    }

    public prepareDateForDB(date: Date | string): string {
        return convertDateToDbFormat(date);
    }
}
